import { applyFilters, doRequest } from "./helpers";

export default class MetaAdSetService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/adsets`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
